/* eslint-disable import/no-named-as-default-member */
import React, { useCallback, useEffect, useState } from 'react';
import rest from 'util/Api';
import dayjs from 'dayjs';
import JsDownload from 'js-file-download';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PaqueryTable from '@paquery-team/lib-table';
import { DEFAULT_PAGINATE } from 'constants/defaultValues';
import API from 'constants/api';
import { ExportDateFormat } from 'constants/dateFormats';
import { notification } from 'antd';
import {
  loadedSelector,
  searchSelector,
  dateSelector,
  statusSelector,
  typeSelector,
} from 'redux/packagesByStoreHistory/selectors';
import { actions } from 'redux/packagesByStoreHistory/slice';
import useStoreHistoryPackages from 'redux/packagesByStoreHistory';
import { useFinalStatusOptions } from 'hooks/useOptions';
import { selectGlobals } from 'redux/globals/selectors';
import useTableDataHistory from '../hooks/useTableDataHistory';

const StoreHistoryPackages = () => {
  const dispatch = useDispatch();
  const { storeId } = useParams();
  useStoreHistoryPackages(storeId);
  const { packages, pageable, columns, colsSM, colsMD, colsLG } =
    useTableDataHistory();
  const globals = useSelector(selectGlobals);
  const date = useSelector(dateSelector);
  const loaded = useSelector(loadedSelector);
  const search = useSelector(searchSelector);
  const packageType = useSelector(typeSelector);
  const status = useSelector(statusSelector);
  const [disabled, setDisabled] = useState(false);
  const filteredFinalStatuses = useFinalStatusOptions();

  useEffect(() => {
    dispatch(actions.resetFilters());
    dispatch(actions.setStore(storeId));
  }, [storeId, dispatch]);

  const searchCallback = useCallback(
    (value) => {
      dispatch(actions.setSearch(value));
    },
    [dispatch],
  );

  const updatePaginate = useCallback(
    (page) => {
      dispatch(actions.setPageable(page));
    },
    [dispatch],
  );

  const updateDate = useCallback(
    (value) => {
      dispatch(actions.setDate(value));
    },
    [dispatch],
  );

  const updateStatus = useCallback(
    (value) => {
      dispatch(actions.setStatus(value));
    },
    [dispatch],
  );
  const updatePackageType = useCallback(
    (newPackageType) => {
      dispatch(actions.setPackageType(newPackageType));
    },
    [dispatch],
  );

  const searcher = {
    onSearching: searchCallback,
    placeholder: 'Código o destinatario',
    allowEmptySearch: true,
  };
  const selectors = [
    {
      onChange: updatePackageType,
      list: globals.packages.type,
      placeholder: 'Tipo de envio',
    },
    {
      list: filteredFinalStatuses,
      onChange: updateStatus,
      placeholder: 'Estado',
    },
  ];
  const handleExportCsv = async () => {
    setDisabled(true);
    try {
      const searchParams = new URLSearchParams({
        search,
        storeId,
        status,
        from: date.from,
        to: date.to,
        packageType,
      });
      const response = await rest.get(
        `${API.reports.storeHistoryPackages}?${searchParams.toString()}`,
        {
          responseType: 'blob',
        },
      );
      const filename = `Paquetes-${dayjs().tz().format(ExportDateFormat)}.xls`;
      JsDownload(response.data, filename);
    } catch (exception) {
      // eslint-disable-next-line no-console
      console.log(exception);
      notification.error({
        message: 'Ha ocurrido un error al traer los paquetes',
        description:
          'Intente nuevamente por favor o informelo a los administradores',
      });
    } finally {
      setDisabled(false);
    }
  };
  return (
    <PaqueryTable
      loading={!loaded}
      header={{
        selectors,
        searcher,
        rangePicker: {
          onDateSelection: updateDate,
          required: {
            value: true,
            message: 'La fecha es requerida',
          },
        },
        onExportCsv: { callback: handleExportCsv, disabled },
        refresh: () => dispatch(actions.refreshPage()),
      }}
      usePackageRowColors
      onChangePaginate={updatePaginate}
      dataSource={packages}
      paginate={pageable || DEFAULT_PAGINATE}
      dataColumns={columns}
      colsForSmallDevice={colsSM}
      colsForMediumDevice={colsMD}
      colsForLargeDevice={colsLG}
    />
  );
};

export default StoreHistoryPackages;
